<app-text-input
  (ngModelChange)="onSearchChange($event)"
  [label]="vm.label"
  [placeHolder]="vm.placeHolder || 'Start typing here...'"
  [ngModel]="searchTerm"
  [ngModelOptions]="{ standalone: true }"
  (onFocus)="showOptions.set(true)"
  [class.icon-at-start]="iconPosition() === 'start'"
  name="search-holder"
>
  @if (vm.loading) {
  <app-loading-spinner icon-end [size]="20" />
  } @else {
  <i icon-end class="fa-regular fa-search"></i>
  }
</app-text-input>

@if (vm.exampleText) {
<p class="hint">{{ vm.exampleText }}</p>
} @if (value) {
<section
  class="selected-item flex-col gap-8 mt-16"
  *ngIf="vm.showSelectedFault"
>
  <section class="flex">
    <p class="label">{{ vm.selectedLabel }}</p>

    <button type="button" class="link-text" (click)="removeSelectedValue()">
      <span>Remove</span>
      @if (vm.showRemoveIcon) {
      <i class="fa-regular fa-trash selected-item__trash-icon"></i>
      }
    </button>
  </section>

  @if (vm.showSelectedValue) {
  <p class="body selected-item__value">
    <i class="fa-light fa-circle-check"></i>
    {{ vm.selectedValue || searchTerm }}
  </p>
  }
</section>
} @if (!value && searchTerm.length && vm.showOptions) {
<p class="body mt-16 mb-12">{{ vm.options.length }} results</p>

@if (vm.options.length) {
<section
  #scrollElement
  class="scroll-container"
  (keydown)="onListKeydown($event)"
>
  <section
    class="virtual-content"
    [style.height.px]="virtualiser.getTotalSize()"
  >
    @for (virtualRow of virtualiser.getVirtualItems(); track virtualRow.key) {
    @if (vm.options[virtualRow.index]; as option) {
    <section
      class="virtual-row"
      [style.transform]="'translateY(' + virtualRow.start + 'px)'"
    >
      <app-radio-button
        (click)="onOptionClick(option)"
        (keydown.enter)="onOptionClick(option)"
        (ngModelChange)="writeValue($event)"
        [index]="virtualRow.index"
        [includeResetOption]="false"
        [optionValue]="option.value"
        [name]="vm.name"
        [ngModel]="value"
        class="flex mb-8"
        variant="select"
      >
        <p class="label">{{ option.title }}</p>
      </app-radio-button>
    </section>
    } }
  </section>
</section>
} }
